(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('orderConfirmationReportController', orderConfirmationReportController);

    orderConfirmationReportController.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$stateParams',
        '$q',
        '$http',
        '$timeout',
        'anonymousReportService',
        'mediaService',
        'objectPropertyNameHandlerService',
        'authService'
    ];

    function orderConfirmationReportController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $q,
        $http,
        $timeout,
        anonymousReportService,
        mediaService,
        objectPropertyNameHandlerService,
        authService
    ) {

        $scope.printReport = printReport;
        $scope.orderId = $stateParams.OrderId;
        $scope.externalToken = $stateParams.ExternalToken;
        $scope.reportLogoImageUrl = '';
        $scope.reportFooterImageUrl = '';
        $scope.deliveryConditionUrl = null;

        if ($state.params.PrintView && $state.params.PrintView === 'true') {
            $rootScope.showNavbar = false;
            $scope.printView = true;
            $('#main-view').addClass('print-view');
            $('#arrival-report-container').addClass('print-view-container');
        }

        function onOrderConfirmationSelect(e) {
            if (e.dataItem) {
                $scope.selectedOrderConfirmation = e.dataItem;
                $scope.refreshOrderData();
            }
        }

        $scope.refreshOrderData = function () {
            $scope.isAgreedPriceNew = false;
            $scope.oldAgreedPrice = null;

            $scope.order = $scope.selectedOrderConfirmation && $scope.selectedOrderConfirmation.orderData ? objectPropertyNameHandlerService.setPascalCaseToCamelCase(JSON.parse($scope.selectedOrderConfirmation.orderData)) : null;

            if ($scope.order) {
                $scope.order.locationName = $scope.order.location ? $scope.order.location.name : '';
                $scope.order.orderProcessName = $scope.order.orderProcess ? $scope.order.orderProcess.name : '';
                $scope.order.customerName = $scope.order.customer ? $scope.order.customer.name : '';
                $scope.order.customerAddress = $scope.order.customer ? $scope.order.customer.address : '';

                if ($scope.order.contactPersons) {
                    $scope.order.contactPersonName = $scope.order.contactPersons && $scope.order.contactPersons.length ? $scope.order.contactPersons.map(c => c.firstName + " " + c.lastName).join(', ') : '';
                } else if ($scope.order.contactPerson) {
                    $scope.order.contactPersonName = $scope.order.contactPerson ? `${$scope.order.contactPerson.firstName} ${$scope.order.contactPerson.lastName}` : '';
                } else {
                    $scope.order.contactPersonName = null;
                }

                $scope.order.orderDate = moment(new Date($scope.order.orderDate)).format('DD.MM.YYYY HH:mm');
                $scope.order.projectManagerName = $scope.order.projectManagerObject ? $scope.order.projectManagerObject.displayName : '';
                $scope.currentDate = moment(new Date()).format('DD.MM.YYYY HH:mm');
            }

            // Compare agreedPrice of current order confirmation with previous
            if ($scope.orderConfirmations && $scope.orderConfirmations.length > 1) {
                
                var idx = $scope.orderConfirmations.findIndex(function(x) {
                    return x.orderConfirmationId === $scope.selectedOrderConfirmation.orderConfirmationId;
                });

                if (idx > -1 && idx < $scope.orderConfirmations.length - 1) {
                    var prevData = JSON.parse($scope.orderConfirmations[idx + 1].orderData);
                    var prevPrice = prevData.AgreedPrice || prevData.agreedPrice;

                    if (prevPrice !== $scope.order.agreedPrice) {
                        $scope.isAgreedPriceNew = true;
                        $scope.oldAgreedPrice = prevPrice;
                    }
                }
            }

            // Handle Logos
            $scope.contractorId = $scope.order ? $scope.order.contractorId : null;
            if ($scope.contractorId) {
                $scope.reportLogoImageUrl = `https://naviaqas.blob.core.windows.net/logos/logo-order-confirmation-${$scope.contractorId}.png`;
                $http.get($scope.reportLogoImageUrl, { headers: { 'Anonymous': '' }, responseType: 'blob' })
                    .catch(() => {
                        $scope.reportLogoImageUrl = `https://naviaqas.blob.core.windows.net/logos/logo-e083f410-67ab-e611-a3b0-f23cffe3d187.png`;
                    });

                $scope.reportFooterImageUrl = `https://naviaqas.blob.core.windows.net/logos/footer-${$scope.contractorId}.png`;
                $http.get($scope.reportFooterImageUrl, { headers: { 'Anonymous': '' }, responseType: 'blob' })
                    .catch(() => {
                        $scope.reportFooterImageUrl = `https://naviaqas.blob.core.windows.net/logos/footer.png`;
                    });
            } else {
                $scope.reportLogoImageUrl = `https://naviaqas.blob.core.windows.net/logos/logo-e083f410-67ab-e611-a3b0-f23cffe3d187.png`;
                $scope.reportFooterImageUrl = `https://naviaqas.blob.core.windows.net/logos/footer.png`;
            }

            $timeout(() => $scope.$apply());
        };

        initController();
        function initController() {
            $rootScope.$broadcast('showBusyIndicator', {
                id: 'orderConfirmationIndicator',
                destination: '#main-view',
                overlay: true
            });

            let requests = [];
            if ($scope.externalToken) {
                authService.loginWithExternalToken(authToken => {
                    requests = {
                        getOrderConfirmationContent: anonymousReportService.getOrderConfirmationContentByExternalToken($scope.externalToken, authToken.token),
                    }
                    getOrderConfirmationData(requests);
                })
            } else {
                requests = {
                    getOrderConfirmationContent: anonymousReportService.getOrderConfirmationContent($scope.orderId),
                }
                getOrderConfirmationData(requests);
            } 
        }

        function getOrderConfirmationData(requests) {
            $q.all(requests).then(function (result) {
                var confirmations = result.getOrderConfirmationContent.orderConfirmations;
                $scope.deliveryCondition = result.getOrderConfirmationContent.deliveryCondition;

                if (confirmations.length > 1) {
                    confirmations.forEach(function (oc, index) {
                        var date = new Date(oc.createdOn);
                        var day = ('0' + date.getDate()).slice(-2);
                        var month = ('0' + (date.getMonth() + 1)).slice(-2);
                        var year = date.getFullYear();
                        var hours = ('0' + date.getHours()).slice(-2);
                        var minutes = ('0' + date.getMinutes()).slice(-2);
                        var number = confirmations.length - index;
                        
                        oc.label = 'Revisjon #' + number + ' ' + day + '-' + month + '-' + year + ' ' + hours + ':' + minutes;
                    });
                }

                var initialIndex = Math.max(0, confirmations.findIndex(c => c.orderConfirmationId === $stateParams.OrderConfirmationId));
                
                $scope.orderConfirmations = confirmations;
                $scope.selectedOrderConfirmation = confirmations[initialIndex];

                $scope.orderConfirmationOptions = {
                    dataSource: confirmations,
                    dataTextField: "label",
                    dataValueField: "label",
                    valuePrimitive: false,
                    index: initialIndex,
                    select: onOrderConfirmationSelect
                };

                $scope.refreshOrderData();

                if ($scope.deliveryCondition && $scope.deliveryCondition.mediaId) {
                    $scope.deliveryConditionUrl = mediaService.createMediaUrlMediaBank($scope.deliveryCondition.mediaId);
                }

                if ($scope.orderConfirmations.length > 1) {
                    $scope.hasMultipleOrderConfirmations = true;
                }

                $rootScope.$broadcast('hideBusyIndicator', 'orderConfirmationIndicator');
            });
        }

        function printReport() {
            $rootScope.showNavbar = false;
            $scope.printView = true;
            $('#main-view').addClass('print-view');
            $('#order-confirmation-report-container').addClass('print-view-container');
            document.title = "Order-confirmation - " + kendo.toString(new Date(), 'HH:mm dd.MM.yyyy');
            window.print();

            setTimeout(function(){
                $rootScope.$broadcast('showBusyIndicator', {
                    id: 'orderConfirmationIndicator',
                    destination: '#main-view',
                    overlay: true
                });

                $rootScope.showNavbar = true;
                $scope.printView = false;
                document.title = "Naviaq Webinnsyn";
                $('#main-view').removeClass('print-view');
                $('#order-confirmation-report-container').removeClass('print-view-container');
                $rootScope.$broadcast('hideBusyIndicator', 'orderConfirmationIndicator');
            }, 1);
        }

    }
})();
